import { useLocation, useNavigate } from "react-router-dom";
import { readRedirectTo } from "@/features/auth/utils/post-auth-redirect";
import { HomeownerOnboardingFlow } from "@/features/onboarding/components/homeowner-onboarding-flow";
import { useLeaveOnceOnboarded } from "@/features/onboarding/hooks/use-leave-once-onboarded";
import { useOnboardingPrefill } from "@/features/onboarding/hooks/use-onboarding-prefill";
import {
	OnboardingExitControl,
	useOnboardingExit,
} from "@/features/roles/components/back-to-role";
import { analytics } from "@/services/analytics.service";

export function HomeownerOnboardingPage() {
	const navigate = useNavigate();
	const location = useLocation();
	// Set when a route guard diverted the visitor here mid-journey; the
	// page they were heading for outranks this role's landing page.
	const redirectTo = readRedirectTo(location.state);
	const markCompletedHere = useLeaveOnceOnboarded(redirectTo ?? "/home");
	const exit = useOnboardingExit(() =>
		navigate("/onboarding", {
			state: {
				allowSelection: true,
				...(redirectTo ? { redirectTo } : {}),
			},
		}),
	);

	// Only an account adding a role has details to carry over.
	const prefill = useOnboardingPrefill(exit.backTo !== null);

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-dashboard-warm-350 px-4 py-8">
			<div className="w-full max-w-lg">
				<HomeownerOnboardingFlow
					onExit={exit.onExit}
					exitControl={<OnboardingExitControl exit={exit} />}
					prefill={prefill}
					onProfileCreated={() => {
						markCompletedHere();
						analytics.profile.homeownerCompleted();
					}}
					onFinished={() => navigate(redirectTo ?? "/home")}
				/>
			</div>
		</div>
	);
}
